<template>
    <div class="category mb-5">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <Shoplist
            :brands="metadata.brands"
            :variations="metadata.variations"
            :products="products"
            :title="page_title"
            :total="total"
            :limit="products_limit"
            :image="showcase.image"
            :currentSort="currentSort"
        />
    </div>
</template>
<script>
    import Breadcrumb from '~/components/Breadcrumb';
    import utils from "~/mixins/utils";
    import Shoplist from "~/components/Shoplist";

    export default {
        mixins: [
            utils
        ],
        components: {
            Shoplist,
            Breadcrumb,
        },
        head() {
            return {
                title: this.page_title
            }
        },
        data() {
            return {
                categories: [],
                category: {},
                showcase: {},
                currentSort: ''
            }
        },
        computed: {
            breadcrumb() {
                let link = '/categoria';
                let breadcrumb = [
                    {
                        name: 'Home',
                        link: '/'
                    },
                    {
                        name: this.page_title,
                        link: null
                    }
                ];
                return breadcrumb;
            },
            page_title() {
                try {
                    return this.showcase.name
                } catch (e) {
                    console.error(e)
                }
                return ''
            },
            products_limit() {
                return this.$route.query.limit || 12
            },
        },
        validate({params}) {
            return /^[a-zA-Z0-9_-]+$/.test(params.alias)
        },
        watchQuery: ['page', 'sort', 'sort_field', 'sort_value', 'limit', 'brand_code', 'filter_brands', 'filter_variations'],
        async asyncData({params, query, res, $axios, req, app, error, store}) {
            const products_limit = query.limit || 12;
            const sortMap = {
                'price_asc': 'price',
                'price_desc': '-price',
                'name_asc': 'name',
                'name_desc': '-name',
            };
            let currentSort = ''
            if (!query.sort) {
                currentSort = sortMap[store.state.config.modules?.shoplist?.default_sort] || 'relevance'
                query.sort = currentSort
            }
            try {
                const showcase = await $axios.$get(`api/v1/ecommerce/showcase/?alias=${params.alias}`);
                let products_query = `api/v1/ecommerce/products/?showcase_alias=${params.alias}&page=${query.page}&sort_field=${query.sort_field}&sort_value=${query.sort_value}&limit=${products_limit}&show_categories=yes&show_brands=yes&show_variations=yes&thumb=sim&x=340&show_payments=true`;
                if (query.sort) {
                    products_query += `&sort[]=` + query.sort
                    if (!['name', '-name', 'relevance'].includes(query.sort)) {
                        products_query += `&sort[]=-active`
                    }
                }
                if (query.filter_brands) {
                    try {
                        const filter_brands = JSON.parse(query.filter_brands)
                        filter_brands.forEach(el => {
                            products_query += `&filter_brands[]=` + el
                        })
                    } catch (e) {
                        console.log(e)
                    }
                }
                if (query.filter_variations) {
                    try {
                        const filter_variations = JSON.parse(query.filter_variations)
                        filter_variations.forEach(el => {
                            products_query += `&filter_variations[]=` + el
                        })
                    } catch (e) {
                        console.log(e)
                    }
                }
                const products = await $axios.$get(products_query);
                if (!'id' in showcase['data']) {
                    return error({statusCode: 404, message: ''})
                }
                return {
                    metadata: products.metadata,
                    products: products.data,
                    total: products.total_items,
                    showcase: showcase.data,
                    currentSort: currentSort
                }
            } catch (error) {
                console.error(error)
                return error({statusCode: 404, message: error.message})
            }
        }
    }
</script>
